<template>
  <div class="review-questions">
    <template v-if="questionDetails">
      <template v-if="questionDetails.games_id">
        <div
          style="
            display: flex;
            height: 100%;
            align-items: center;
            justify-content: center;
            color: red;
          "
        >
          {{ $t("blendType.load") }}
        </div>
      </template>
      <template v-else>
        <template v-if="questionDetails['steps_category'] == 3">
          <ImageSelectionTransversal
            :list="imgList"
            @changeType="changeType"
            :listData="listData"
          ></ImageSelectionTransversal>
        </template>
        <template
          v-else-if="
            questionDetails['steps_category'] == 10 ||
            questionDetails['steps_category'] == 4
          "
        >
          <ImageSelectionVertical
            :list="imgList"
            @changeType="changeType"
            :listData="listData"
          ></ImageSelectionVertical>
        </template>
        <template v-else-if="questionDetails['steps_category'] == 1">
          <PictureAfterReading
            @changeType="changeType"
            :listData="listData"
          ></PictureAfterReading>
        </template>
        <template v-else-if="questionDetails['steps_category'] == 11">
          <VideoAfterReading
            @changeType="changeType"
            :listData="listData"
          ></VideoAfterReading>
        </template>
        <template
          v-else-if="
            questionDetails['steps_category'] == 13 ||
            questionDetails['steps_category'] == 5
          "
        >
          <MicroAnimation
            v-if="questionDetails.steps_video"
            :from="from"
            :videoSrc="questionDetails.steps_video"
            :videoPoster="''"
            @submitEnd="submitEnd"
          ></MicroAnimation>
        </template>
        <template v-else-if="questionDetails['steps_category'] == 9">
          <LiteralReading
            @changeType="submitOk"
            :listData="listData"
          ></LiteralReading>
        </template>
        <template v-else-if="questionDetails['steps_category'] == 13">
          <Choice @changeType="changeType"></Choice>
        </template>
        <template v-else-if="questionDetails['steps_category'] == 2">
          <Cosplay
            :cosplayData="cosplayData"
            :from="from"
            @changeType="changeType"
          ></Cosplay>
        </template>
      </template>
    </template>

    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>
<script>
import ImageSelectionTransversal from "@/components/StudyCenter/Review/ImageSelectionTransversal"; // 复习之图片选择 横向
import ImageSelectionVertical from "@/components/StudyCenter/Review/ImageSelectionVertical"; // 复习之图片选择纵向
import LiteralReading from "@/components/StudyCenter/Review/LiteralReading"; // 文字泛红跟读
import MicroAnimation from "@/components/StudyCenter/Review/MicroAnimation"; // 微动画
import Cosplay from "@/components/StudyCenter/Review/Cosplay"; // 角色 扮演
import PictureAfterReading from "@/components/StudyCenter/Review/PictureAfterReading"; // 图片轮播跟读
import VideoAfterReading from "@/components/StudyCenter/Review/VideoAfterReading"; // 图片轮播视频
import Choice from "@/components/StudyCenter/Review/Choice"; // 选择

import PopTips from "@/components/popTips";
import ReviewHttp from "../review";
import CommonHttp from "@/utils/http";
import REVIEW_TYPE_JSON from "../type"; // 题目类型
export default {
  name: "review-questions",
  data() {
    return {
      from: "from",
      REVIEW_TYPE_JSON: null,
      questionDetails: null, // 题目 详情

      imgList: [], // 图片数组
      listData: {},

      showOk: false,
      type: 1,
      dialogVisable: false,

      popTipsCont: {
        title: this.$t("blendType.reword"),
        context: `<span class="gold"></span> +4`,
        btns: [
          {
            text: this.$t("Common.confirm"),
            event: "handConfirm",
          },
        ],
      },
    };
  },
  components: {
    ImageSelectionTransversal,
    ImageSelectionVertical,
    LiteralReading,
    MicroAnimation,
    Cosplay,
    PictureAfterReading,
    VideoAfterReading,
    Choice,
    PopTips,
  },
  created() {
    this.updataData();
  },
  activated() {
    this.updataData();
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/ReviewMaps') {
      from.meta.canUpdate = false
    }
    next()
  },
  methods: {
    updataData() {
      this.$store.dispatch("setLoadingStatus", true);
      this.id = this.$route.query.id;
      console.log(this.id,'this.id')
      this.from = this.$route.query.from;
      this.title = this.$route.query.title;
      // this.$emit("setReivewTitle", this.title);
      this.student_id = this.$store.state.currentChild.student_id;
      this.getMapsStepsMedias(this.id);
      this.getGoldTotaling();
    },
    submitEnd(v) {
      if (v == "taskcenter") {
        this.SubmitTask();
      } else {
        this.saveStepsLog({});
      }
    },
    // 获取 金币
    getGoldTotaling() {
      CommonHttp.getGoldTotaling({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        timestamp: new Date().getTime()
      }).then((res) => {
        const { error, result } = res.data;
        if (error == 0) {
          let childInfo = this.$store.state.currentChild;
          childInfo.student_goldprice = result.goldprice;
          this.$Tool.setStorage("currentStuInfo", childInfo);
          this.$store.dispatch("setCurrentChild", childInfo);
        }
      });
    },
    // 获取 资源
    getMapsStepsMedias(steps_id) {
      ReviewHttp.getMapsStepsMedias({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        steps_id,
      }).then((res) => {
        const { error, result } = res.data;
        if (error == 0) {
          this.listData = result.list;
          this.questionDetails = result.list;
          this.$emit("setReivewTitle", this.listData.steps_title);
          if (this.questionDetails.steps_category == 10) {
            this.imgList = result.list.option;
          } else if (this.questionDetails.steps_category == 2) {
            this.cosplayData = this.questionDetails;
          }
        }
        this.$store.dispatch("setLoadingStatus", false);
      });
    },
    // 完成 题目 提交成功
    SubmitTask() {
      ReviewHttp.SubmitTask({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        taskitem_id: this.$route.query.taskitem_id, // 	任务id 仅在任务完成部分的复习模块中需要传
      }).then((res) => {
        const { error, result } = res.data;
        if (error == 0) {
          this.getGoldTotaling();
          const { list } = result;
          if (list.playclass == 0) {
            this.popTipsCont.context = `<span class="gold"></span> +${result.list.playprice}`;
            let childInfo = this.$store.state.currentChild;
            childInfo.student_goldprice = list.totalPrice;
            this.$Tool.setStorage("currentStuInfo", childInfo);
            this.$store.dispatch("setCurrentChild", childInfo);
          } else {
            this.popTipsCont.context = `<span class="zs-icon"></span> +${result.list.playprice}`;
            let childInfo = this.$store.state.currentChild;
            childInfo.student_diamondprice = list.totalPrice;
            this.$Tool.setStorage("currentStuInfo", childInfo);
            this.$store.dispatch("setCurrentChild", childInfo);
          }
          this.dialogVisable = true;
        }
      });
    },
    // 完成 题目 提交成功
    saveStepsLog(item) {
      ReviewHttp.saveStepsLog({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        steps_id: this.id,
        issucceed: item.issucceed || item.issucceed == 0 ? item.issucceed : 1, // 是否成功
        operatetime: item.operatetime ? item.operatetime : 0, // 闯关使用时间,存秒数
        class: 0, // 闯关模式，0自由闯关1任务闯关
        taskitem_id: this.$route.query.taskitem_id, // 	任务id 仅在任务完成部分的复习模块中需要传
      }).then((res) => {
        const { error, result } = res.data;
        if (error == 0) {
          this.getGoldTotaling();
          const { list } = result;
          if (list.playclass == 0) {
            this.popTipsCont.context = `<span class="gold"></span> +${result.list.playprice}`;
          } else {
            this.popTipsCont.context = `<span class="zs-icon"></span> +${result.list.playprice}`;
          }
          this.dialogVisable = true;
        }
      });
    },
    bakToPrev() {
      // this.$router.go(-1);
      console.log("bakToPrev");
    },
    getData() {
      console.log("getData");
    },
    changeType(item) {
      if (this.from == "taskcenter") {
        this.SubmitTask();
      } else {
        this.saveStepsLog(item);
      }
    },
    submitOk() {
      if (this.from == "taskcenter") {
        this.SubmitTask();
      } else {
        this.saveStepsLog({});
      }
    },
    handleCloseTip() {
      this.dialogVisable = false;
    },
    handConfirm() {
      console.log("ok");
      this.dialogVisable = false;
      if (this.questionDetails["steps_category"] != 2) {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style lang="less">
.review-questions {
  height: 100%;
  .prop-content {
    display: flex;
    align-items: center;
    justify-content: center;
    .gold,
    .zs-icon {
      width: 26px;
      height: 26px;
      margin-right: 10px;
      border-radius: 50%;
    }
    .gold {
      background: url(../../../../assets/images/studyCenter/questions/gold-icon.png)
        center center no-repeat;
      background-size: cover;
    }
    .zs-icon {
      background: url(../../../../assets/images/myCenter/diamond.png) center
        center no-repeat;
      background-size: cover;
    }
  }
}
</style>